import api from "api/axios";

export const getDentalFindings = async (params) =>
  api.get("/dental-finding", { params });

export const createDentalFinding = async (payload) =>
  api.post("/dental-finding", payload);

export const updateDentalFinding = async (id, payload) =>
  api.patch(`/dental-finding/${id}`, payload);

/** Deletes the finding AND its treatment list. */
export const deleteDentalFinding = async (id) =>
  api.delete(`/dental-finding/${id}`);

export const getTreatmentsForFinding = async (findingId) =>
  api.get(`/dental-finding-treatment/finding/${findingId}`);

export const setTreatmentsForFinding = async (findingId, treatments) =>
  api.put(`/dental-finding-treatment/finding/${findingId}`, { treatments });
